import type { Activity } from "@lib/activity";
import {
  getSelectedProductIds,
  getSelectedProductNames,
  type ProductType,
} from "@lib/products";

type GTMPixelProps = {
  activity: Activity;
  analyticalConsentGiven: boolean;
  marketingConsentGiven: boolean;
};

type GTMOrderSubmittedProps = {
  activity: Activity;
  orderId: string;
  selectedAllocationIds: string[];
};

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    trackingSessionId?: string;
  }
}

export function loadGTMPixel(code: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const firstScript = document.getElementsByTagName("script")[0];
  const newScriptTag = document.createElement<"script">("script");
  newScriptTag.async = true;
  newScriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${code}`;
  firstScript.parentNode?.insertBefore(newScriptTag, firstScript);
}

export function setInitialDataLayerVariables({
  activity,
  analyticalConsentGiven,
  marketingConsentGiven,
}: GTMPixelProps) {
  if (window.dataLayer) {
    const dataLayer = window.dataLayer || [];

    dataLayer.push({
      activityCode: activity.code,
      activityName: activity.name,
      activityId: activity.id,
      campaignCode: activity.campaign.code,
      campaignName: activity.campaign.name,
      campaignId: activity.campaign.id,
      sessionId: window.trackingSessionId || "unknown",
      cookieConsentAnalytical: analyticalConsentGiven,
      cookieConsentMarketing: marketingConsentGiven,
    });
  }
}

export function sendOrderSubmittedGTMEvent({
  activity,
  orderId,
  selectedAllocationIds,
}: GTMOrderSubmittedProps) {
  if (window.dataLayer) {
    const dataLayer = window.dataLayer || [];

    const chosenProductIds = getSelectedProductIds(
      activity.products as ProductType,
      selectedAllocationIds,
    );

    const chosenProductNames = getSelectedProductNames(
      activity.products as ProductType,
      selectedAllocationIds,
    );

    dataLayer.push({
      event: "submitOrder",
      productName: chosenProductNames,
      productId: chosenProductIds,
      orderId: orderId,
    });
  }
}
